import Vue from 'vue';

Vue.filter('currencyFromCents', value => {
    if(value){
        return  (value / 100).toFixed(2);
    }else{
        return 0;
    }
});
